<template lang="pug">
.registration-success
	VueFeedback
		template(slot="feedback-icon")
			img(src="../../../assets/img/applications/registration/email-success.svg")
		template(slot="feedback-title") Nézd meg az e-mail-fiókod!
		template(slot="feedback-content")
			| A továbblépéshez szükséges adatokat elküldtük
			br
			| a(z)
			strong &nbsp;{{ email }}&nbsp;
			| e-mail-címre.
			br
			| Ha nem kaptad meg az e-mailt, ellenőrizd a spam mappád!
	VueButton(slot="feedback-action", @click="$emit('retry')", button-type="link") Rosszul adtam meg az e-mail-címemet
</template>

<script>
import VueFeedback from '@ui-common/vue-feedback';
import VueButton from '@ui-common/vue-button';
export default {
	props: {
		email: {
			required: true
		}
	},
	components: {
		VueFeedback,
		VueButton
	},
	created() {
		this.$gtm.trackEvent({
			event: 'registrationSuccess'
		});
	}
};
</script>
<style lang="scss">
.registration-success {
	align-items: center;
	display: flex;
	flex-direction: column;
}

.registration-success .sf-feedback {
	margin-bottom: 48px;
	max-width: 544px;
}

.registration-success .sf-btn--link {
	margin-bottom: 32px;
}
</style>
